import ReactDOM from "react-dom/client"
import "./styles/App.scss"
import "./styles/fonts.scss"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import "scroll-behavior-polyfill"
import "react-device-frameset/styles/marvel-devices.min.css"

// keep enough frames to identify the app code in captured exceptions (Chrome defaults to 10)
Error.stackTraceLimit = 50

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(<App />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals(console.info)
